import { createServer, Model, hasMany, belongsTo } from 'miragejs';
import { apiUrl } from '@/config';

import alertsRoutes from './routes/alerts';
import authRoutes from './routes/auth';
import businessProfilesRoutes from './routes/business-profiles';
import dashboardRoutes from './routes/dashboard';
import emailsRoutes from './routes/emails';
import feedItemsRoutes from './routes/feed-items';
import filtersRoutes from './routes/filters';
import labelsRoutes from './routes/labels';
import moderationReportRoutes from './routes/moderation-report';
import profilesRoutes from './routes/profiles';
import rulesRoutes from './routes/rules';
import searchRoutes from './routes/search';
import statsRoutes from './routes/stats';
import streamsRoutes from './routes/streams';
import teamsRoutes from './routes/teams';
import topicsRoutes from './routes/topics';
import usersRoutes from './routes/users';
import webhooksRoutes from './routes/webhooks';
import excludeTermsRoutes from './routes/exclude-terms';

export default createServer({
    models: {
        account: Model,
        accountContext: Model,
        annotation: Model.extend({
            layer: belongsTo()
        }),
        alert: Model,
        brandContext: Model,
        businessProfile: Model,
        dashboardTemplate: Model,
        email: Model,
        feedItem: Model,
        layer: Model.extend({
            annotations: hasMany()
        }),
        user: Model.extend({
            teams: hasMany()
        }),
        profileItem: Model,
        profile: Model,
        team: Model.extend({
            users: hasMany()
        }),
        teamContext: Model,
        topic: Model,
        label: Model,
        rule: Model,
        searchFolder: Model,
        searchItem: Model,
        webhook: Model,
        excludeTerm: Model
    },

    routes() {
        this.urlPrefix = apiUrl;

        alertsRoutes(this);
        authRoutes(this);
        businessProfilesRoutes(this);
        dashboardRoutes(this);
        emailsRoutes(this);
        feedItemsRoutes(this);
        filtersRoutes(this);
        labelsRoutes(this);
        moderationReportRoutes(this);
        profilesRoutes(this);
        rulesRoutes(this);
        searchRoutes(this);
        statsRoutes(this);
        streamsRoutes(this);
        teamsRoutes(this);
        topicsRoutes(this);
        usersRoutes(this);
        webhooksRoutes(this);
        excludeTermsRoutes(this);

        this.get('/example-csv', () => {
            const { content } = require('./data/example-report-csv-content');

            return content;
        });

        this.passthrough('https://api.segment.io/**');
        this.passthrough('https://cdn.segment.com/**');
        this.passthrough('https://r.lr-in.com/**');
        this.passthrough('https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json');
        this.passthrough('https://g.tenor.com/**');
        this.passthrough('https://unpkg.com/**');

        // for exporting images from html to png
        this.passthrough('https://pngset.com/**');
        this.passthrough('http://localhost:8080/**');
        this.passthrough('https://countryflagsapi.com/**');
        this.passthrough('https://api-js.mixpanel.com/**');
    }
});
